<div class="spinner" *ngIf="spinnerService.showSpinner" @inOut>
  <div class="spinner-container">
      <div class="spinner-content">
          <ng-lottie [options]="options"></ng-lottie>
      </div>
  </div>
</div>
